define('base/model',['require','exports','module','app'],function(require, exports, module) {
    "use strict";

    var app = require("app");

    var BaseModel = Backbone.Model.extend({
        initRequestEvents: function() {
            this.isRequest = false;
            this.isError = false;
            this.status = null;
            this.on("request", function() {
                this.isRequest = true;
            });
            this.on("sync", function(model, response) {
                this.status = (response && response.status) ? response.status : '';
                this.isRequest = false;
                this.isError = false;
            });
            this.on("error", function(model, response) {
                if (typeof response !== 'undefined'){
                  this.status = response.status;
                  this.response = response;
                } else {
                  this.status = '';
                }
                this.isError = true;
                this.isRequest = false;
            });
        }

    });

    module.exports = BaseModel;
});

